import { styled } from 'linaria/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const DATA_QA_DELIVERY_METHODS_DEFAULT = 'delivery-methods-default';

export const PdpDeliverySEOStub: React.FC = () => {
  const { t } = useTranslation();

  return (
    <SEOContent data-qa={DATA_QA_DELIVERY_METHODS_DEFAULT} slot="extra-info">
      <span>{t('product-info.delivery.three-hundred')}</span>
    </SEOContent>
  );
};

export const SEOContent = styled.div`
  display: none;
`;
